import { FavoritePageStoreType } from '@/types/storeTypes/favoritePageStoreType'
import { StateCreatorType } from '@/types/storeTypes/storeType'

export const favoritePageStore: StateCreatorType<FavoritePageStoreType> = (
  set,
) => ({
  favoritePages: null,
  initFavoritePagesStore: (favoritePages) =>
    set(
      (state) => {
        state.favoritePage.favoritePages = favoritePages
      },
      false,
      'initFavoritePagesStore',
    ),
  addFavoritePageStore: (page) => {
    set(
      (state) => {
        if (!state.favoritePage.favoritePages) {
          state.favoritePage.favoritePages = {}
        }
        state.favoritePage.favoritePages[page.id] = page
      },
      false,
      'addFavoritePageStore',
    )
  },
  removeFavoritePageStore: (pageId) =>
    set(
      (state) => {
        if (state.favoritePage.favoritePages) {
          delete state.favoritePage.favoritePages[pageId]
        }
      },
      false,
      'removeFavoritePageStore',
    ),
})
